<template>
  <PageTemplate>
    <BackButton
        :label="$t('general.button.back')"
        :to="{ name: 'billingLatestBills' }"
        marginBottom="5"/>

    <h6 class="element-header">
      Rechnungslegung
    </h6>

    <div class="element-box">
      <div class="row">
        <div class="col-6">
          <h5 class="form-header mb-4">
            Rechnungsanpassung
          </h5>
        </div>
      </div>

      <div class="ps-3 pe-2 mb-5">
        <div class="row mt-2">
          <div class="header">
            <div class="header_left">
              <div class="header_left_content">
                <p style="font-weight: bold; margin-bottom: 5px;">
                  BSG Bildungsinstitut für Soziales und Gesundheit GmbH
                </p>

                <p>{{ billData?.address }}</p>
                <p>{{ billData?.zipCode }}</p>
                <p>{{ billData?.country }}</p>
              </div>
            </div>

            <div class="header_right">
              <img alt="" style="width: 250px" src="@/assets/img/bsg-logo-new.png"
                   class="img-fluid">
            </div>
          </div>

          <div class="receiver">
            <div class="receiver_left">
              <p style="font-weight: bold; margin-bottom: 5px;">Empfänger:</p>
              <p style="font-weight: bold; margin-bottom: 3px;">
                {{ billData?.client ? billData?.client?.registrationOffice : '' }}
              </p>

              <p>{{ billData?.client ? billData?.client.forAttention : '' }}</p>
              <p>{{ billData?.client ? billData?.client.addressFirst : '' }}</p>
              <p>{{ billData?.client ? billData?.client.addressSecond : '' }}</p>
              <p>{{ billData?.client ? billData?.client.zip : '' }} {{
                  billData?.client ? billData?.client.city : ''
                }}</p>

              <p style="color: white;">-------------------------</p>
              <p style="color: white;">-------------------------</p>

              <p style="font-weight: bold; margin-bottom: 5px;">Patient:</p>
              <p style="font-weight: bold; margin-bottom: 3px;">
                {{ billData?.unemployed?.firstName }} {{ billData?.unemployed?.lastName }}
              </p>
              <p>{{ billData?.unemployed?.address }}</p>
              <p>{{ billData?.unemployed?.zip }} {{ billData?.unemployed?.city }}</p>
              <p>Geb. Datum: {{ billData?.unemployed?.birthdate }}</p>
              <p>Karten IK: {{ billData?.unemployed?.cardIK }}</p>
            </div>

            <div class="receiver_right">
              <div class="content_left">
                <p>Rechnungsdatum:</p>
                <p style="margin-bottom: 15px;">Rechnungsnummer:</p>

                <p>Kundennummer:</p>
                <p>Ansprechpartner:</p>
                <p style="color: white;">-------------------------</p>
                <p style="color: white;">-------------------------</p>

                <p v-if="billData?.socioTherapyCoaching?.clerk && billData?.socioTherapyCoaching.clerk.trim().length > 0"
                   style="color: white; padding-top: -2px">
                  -------------------------
                </p>

                <p style="margin-top: 15px;">Leistungserbringer:</p>
                <p>Kostenträger IK:</p>
                <p>interne Kennung:</p>
                <p>KST1:</p>
                <p>KST2:</p>
              </div>

              <div class="content_right">
                <p>{{ billData?.invoiceDate }}</p>
                <p style="margin-bottom: 15px; font-weight: bold; font-size:16px; text-decoration: underline">
                  {{ billData?.billNumber }}
                </p>

                <p v-if="billData?.client?.customerNumber" style="margin-top: 7px;">
                  {{ billData?.client?.customerNumber }}
                </p>
                <p v-else style="color: white; padding-top: 5px;">-------------------------</p>

                <p style="margin-bottom: 6px;">Buchhaltung</p>
                <p>02361 – 388 59 43</p>
                <p style="margin-bottom: 4px;">{{ billData?.contactEmail }}</p>

                <p>{{ billData?.socioTherapyCoaching?.clerk }}</p>

                <p style="margin-top: 9px;">IK 490504828</p>

                <p v-if="billData?.client?.payerIk && billData?.client.payerIk.trim().length > 0">
                  {{ billData?.client?.payerIk }}
                </p>
                <p v-else style="color: white;">-------------------------</p>

                <p style="margin-top: 3px;">SOZ</p>
                <p>J STDI</p>
                <p>{{ billData?.costCenter2 }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <form @submit.prevent="">
        <table id="itemsTable" class="table" style="overflow-x:auto;">
          <thead style="background: #389142; color: white; font-size: 12px">
          <tr>
            <th style="text-align: left;
              padding: 6px 6px 6px 15px;
              border-top-left-radius: 3px;
              border-bottom-left-radius: 3px;">
              Termine:
            </th>
            <th style="padding: 6px 6px 6px 15px;">Bezeichnung</th>
            <th style="text-align: center; padding: 6px">Anzahl</th>
            <th style="text-align: center; padding: 6px">Einheit</th>
            <th style="text-align: center; padding: 6px">Mwst</th>
            <th style="text-align: right; padding: 6px 15px 6px 6px">Einzelpreis</th>
            <th style="text-align: right;
            padding: 6px 18px 6px 6px;
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;">
              Gesamt
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in form.billItems" :key="index">
            <td>
              <input v-if="item['termin']"
                     type="text"
                     :value="item['termin']"
                     readonly
                     class="form-control"/>
            </td>
            <td>
              <input
                  type="text"
                  :value="item['description']"
                  readonly
                  class="form-control"/>
            </td>
            <td style="width: 7%">
              <input
                  :id="'units' + index"
                  type="text"
                  v-model="form.billItems[index].units"
                  readonly
                  class="form-control text-end"/>
            </td>
            <td style="text-align: center; width: 8%"></td>
            <td style="text-align: center; width: 6%">0 %</td>

            <td style="text-align: right; width: 10%;">
              <BaseNumber
                  :id="'cost' + index"
                  :is-currency="true"
                  v-model="form.billItems[index].cost"
                  readonly="readonly"
                  classFormGroup="mb-0"
                  :decimal-places=2
                  @input="updateItemTotal(index)"/>
            </td>

            <td style="text-align: right; width: 10%;">
              <BaseNumber
                  :id="'total' + index"
                  :is-currency="true"
                  v-model="form.billItems[index].total"
                  readonly="readonly"
                  classFormGroup="mb-0"
                  :decimal-places=2
                  disabled="disabled"
                  @input="updateItemTotal(index)"/>
            </td>
          </tr>
          </tbody>
        </table>
        <table class="table" style="overflow-x:auto;">
          <tbody>
          <tr>
            <td style="text-align: left; width: 12%;"></td>
            <td></td>
            <td style="width: 7%"></td>
            <td style="text-align: center; width: 8%"></td>
            <td style="text-align: center; width: 6%"></td>
            <td style="text-align: right; width: 20%;">
              <span style="padding-right: 5px; font-size: 18px">Gesamtbetrag:</span>
              <span style="font-size: 18px">&euro;</span>
            </td>
            <td style="text-align: right; width: 10%;">
              <input
                  type="text"
                  :value="form.billSum"
                  readonly
                  class="form-control text-end"/>
            </td>
          </tr>
          </tbody>
        </table>

        <div class="text-center mt-2">
          <button type="button" @click="createAdjustment" class="btn btn-primary">Rechnungsvorschau</button>
        </div>
      </form>
    </div>

  </PageTemplate>

  <ModalConfirm
      v-model="showConfirmModal"
      :confirmationQuestion="`Sind Sie sicher, dass Sie eine Anpassung für die Rechnungsnummer ${billData?.billNumber} erstellen möchten?`"
      header="Rechnungsanpassung"
      :onConfirm="confirmCreateAdjustment"/>

</template>

<script setup>
import billingService from '@/api/Billing';
import BaseNumber from '@/components/base/BaseNumber.vue';
import BackButton from '@/components/button/BackButton.vue';
import ModalConfirm from '@/components/modal/ModalConfirm.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import router from '@/router';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const route            = useRoute();
const { t }            = useI18n();
const billId           = route.params.id;
const billData         = ref();
const showConfirmModal = ref(false);
const isSubmitting     = ref(false);

const form = ref({
  billSum: 0,
  billItems: [],
});

async function getBillDetails() {
  try {
    const { data } = await billingService.getBillDetails(+billId);
    billData.value = data.data.bill;

    form.value.billSum   = data.data.bill.nonFormatedSum;
    form.value.billItems = data.data.billItems;
  } catch (error) {
    await ErrorToast(error);
  }
}

const updateItemTotal = (index) => {
  const item = form.value.billItems[ index ];

  // Precision fix for item total
  item.total = Math.round((item.units * item.cost) * 100) / 100;

  // Precision fix for bill total
  form.value.billSum = Math.round(
      form.value.billItems.reduce((sum, item) => sum + item.total, 0) * 100,
  ) / 100;
};

function createAdjustment() {
  showConfirmModal.value = true;
}

async function confirmCreateAdjustment() {
  showConfirmModal.value = false;

  try {
    form.value.billId = billId;

    await billingService.socioTherapyCoachingBillCorrection(form.value);

    await router.push({ name: 'billingLatestBills' });
    isSubmitting.value = false;

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

onMounted(async () => {
  CloseToast();
  await getBillDetails();
});
</script>

<style scoped>
.header {
  margin-top: 30px;
  margin-bottom: 20px;
  overflow: hidden;
  width: 65%;
}

.header_left {
  width: 70%;
  float: left;
}

.header_left .header_left_content p {
  margin-top: 2px;
  margin-bottom: 3px;
}

.header_right {
  width: 30%;
  float: left;
  text-align: right;
}

.receiver {
  margin-bottom: 5px;
  overflow: hidden;
  width: 65%;
}

.receiver_left {
  width: 55%;
  float: left;
}

.receiver_left p {
  margin-top: 2px;
  margin-bottom: 3px;
}

.receiver_right {
  width: 45%;
  float: left;
  padding-left: 15px;
}

.receiver_right p {
  margin-top: 2px;
  margin-bottom: 3px;
}

.receiver_right .content_left {
  width: 50%;
  float: left;
}

.receiver_right .content_right {
  width: 50%;
  float: left;
  text-align: right;
}

.bill_number {
  margin-top: 10px;
}

.bill_number p {
  margin-bottom: 3px;
  margin-top: 2px;
}
</style>